// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "" + "vimeoPlayer" + "." + "d4918fa621cee7a0" + ".js"
}